<div>
  <p class="read-recovery-codes__content-title">
    {{
      (allUsed
        ? 'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.GENERATE.TITLE_USED'
        : 'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.GENERATE.TITLE'
      ) | translate
    }}
  </p>

  <p class="read-recovery-codes__content-description">
    {{
      (allUsed
        ? 'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.GENERATE.DESCRIPTION_USED'
        : 'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.GENERATE.DESCRIPTION'
      ) | translate
    }}
  </p>

  <div class="read-recovery-codes__content__buttons">
    <button
      mat-raised-button
      class="read-recovery-codes__content__buttons-button read-recovery-codes__content__buttons-button--gray"
      (click)="back.emit()"
      [disabled]="isLoading"
    >
      {{ 'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.GENERATE.CANCEL' | translate }}
    </button>

    <button
      mat-raised-button
      class="read-recovery-codes__content__buttons-button"
      (click)="confirmRegenerate.emit()"
      [disabled]="isLoading"
    >
      {{ 'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.GENERATE.NEXT' | translate }}
    </button>
  </div>
</div>
